import { render } from "./Application.vue?vue&type=template&id=57a63c17&scoped=true"
import script from "./Application.vue?vue&type=script&lang=js"
export * from "./Application.vue?vue&type=script&lang=js"

import "./Application.vue?vue&type=style&index=0&id=57a63c17&scoped=true&lang=css"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a63c17"]])

export default __exports__